// COD-877: pipe-separated 3PI property fields shared by the 3PI segment events
// (Third Party Results Loaded and Third Party Property Clicked). PWA parity: pwa/src/tracking/search/segmentSearchTracker.js.

const FREE_BREAKFAST_FACILITY_ID = 'BREAKFASTINCLUDED';
const FREE_WIFI_FACILITY_ID = 'FREEWIFI';
const PROPERTY_CATEGORY_TRACKING_LENGTH = 5;

function hasFacilityId(property, facilityId) {
  for (const category of property?.facilities || []) {
    for (const facility of category?.facilities || []) {
      if (facility?.id === facilityId) {
        return true;
      }
    }
  }

  return false;
}

export function extractThreePiPropertyData(properties) {
  if (!properties?.length) {
    return {
      third_party_properties: '',
      third_party_properties_free_breakfast: '',
      third_party_properties_free_wifi: '',
      third_party_properties_free_cancellation_label: '',
      third_party_properties_new_property_label: '',
      third_party_properties_esg: '',
      third_party_properties_property_category: '',
    };
  }

  const propertyData = properties.reduce(
    (acc, property) => {
      acc.ids.push(property?.id?.toString() || '');
      // COD-989: wifi/breakfast come from facilities (full list), not presentation badges (capped at 5).
      acc.freeBreakfast.push(hasFacilityId(property, FREE_BREAKFAST_FACILITY_ID) ? '1' : '0');
      acc.freeWifi.push(hasFacilityId(property, FREE_WIFI_FACILITY_ID) ? '1' : '0');
      acc.freeCancellation.push(property?.hasFreeCancellation ? '1' : '0');
      acc.newPropertyLabel.push(property?.isNew ? '1' : '0');
      // @devNote: 3PI inventory has no sustainability data, so esg is always 0 (matches PWA).
      acc.esg.push('0');
      acc.propertyCategory.push(
        (property?.propertyCategory || property?.type || '')
          .substring(0, PROPERTY_CATEGORY_TRACKING_LENGTH)
          .toUpperCase(),
      );
      return acc;
    },
    {
      ids: [],
      freeBreakfast: [],
      freeWifi: [],
      freeCancellation: [],
      newPropertyLabel: [],
      esg: [],
      propertyCategory: [],
    },
  );

  return {
    third_party_properties: propertyData.ids.join('|'),
    third_party_properties_free_breakfast: propertyData.freeBreakfast.join('|'),
    third_party_properties_free_wifi: propertyData.freeWifi.join('|'),
    third_party_properties_free_cancellation_label: propertyData.freeCancellation.join('|'),
    third_party_properties_new_property_label: propertyData.newPropertyLabel.join('|'),
    third_party_properties_esg: propertyData.esg.join('|'),
    third_party_properties_property_category: propertyData.propertyCategory.join('|'),
  };
}

// COD-905: Destination Landing Page Viewed must send HW-only counts.
// 3PI-only cities: number_results = 0 and top_30_properties = null.
export function getHwDestinationLandingParams(hwCount, top30Ids) {
  const ids = top30Ids || [];
  return {
    number_results: hwCount ?? 0,
    top_30_properties: ids.length ? ids.join('|') : null,
  };
}
